'use client';

import { c as _c } from "react/compiler-runtime";
import { Skeleton } from '@sola/ark-core/atoms/skeleton/skeleton.tsx';
import { useHomepageGreeting } from './homepage-greeting.logic.ts';
const flagStyle = {
  fontSize: '16px',
  lineHeight: '16px'
} as const;
export const HomepageGreeting = () => {
  const $ = _c(5);
  const {
    hasGreetingError,
    isLoadingGreeting,
    name,
    selectedLanguage,
    subtitle
  } = useHomepageGreeting();
  if (hasGreetingError) {
    return null;
  }
  let t0;
  if ($[0] !== isLoadingGreeting || $[1] !== name || $[2] !== selectedLanguage || $[3] !== subtitle) {
    t0 = <div className="HomepageGreeting flex flex-col gap-snug-md w-full py-comfy-sm">{isLoadingGreeting ? <div className="flex flex-col gap-snug-md" aria-label="Loading greeting" aria-busy="true"><Skeleton height={36} width="min(100%, 18rem)" /><Skeleton height={20} width="min(100%, 24rem)" /></div> : <><h1 className="heading-sm heading-neutral-amplified md:heading-md">{selectedLanguage.greeting}<span className="relative" aria-hidden="true"><span className="absolute -top-3 left-1/2 -translate-x-1/2 leading-none pointer-events-none inline-block w-4 h-4 text-center" style={flagStyle} role="img" aria-label={selectedLanguage.name}>{selectedLanguage.flag}</span>{","}</span>{name ? ` ${name}!` : "!"}</h1><p className="body-sm body-neutral-mild">{subtitle}</p></>}</div>;
    $[0] = isLoadingGreeting;
    $[1] = name;
    $[2] = selectedLanguage;
    $[3] = subtitle;
    $[4] = t0;
  } else {
    t0 = $[4];
  }
  return t0;
};